import { render } from "./confetti.vue?vue&type=template&id=52e249fe&lang=pug"
import script from "./confetti.vue?vue&type=script&lang=js"
export * from "./confetti.vue?vue&type=script&lang=js"

import "./confetti.vue?vue&type=style&index=0&id=52e249fe&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__